import { tempoApi } from '@/lib/api/tempoApi';
import type { Plan, PlanCreateRequest, PlanUpdateRequest } from '@/lib/api/types/adaptivePlanner';

export const getPlans = async ({ limit }: { limit?: number } = {}): Promise<Plan[]> => {
  const searchParams = new URLSearchParams();

  if (limit !== undefined) {
    searchParams.set('limit', limit.toString());
  }

  const url = `api/v1/adaptive-planner/plans${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;

  const response = await tempoApi().get(url).json<Plan[]>();
  return response;
};

const getPlan = async ({ planId }: { planId: number }): Promise<Plan> => {
  const response = await tempoApi().get(`api/v1/adaptive-planner/plans/${planId}`).json<Plan>();
  return response;
};

const createPlan = async ({ data }: { data: PlanCreateRequest }): Promise<Plan> => {
  const response = await tempoApi()
    .post('api/v1/adaptive-planner/plans', {
      json: data,
    })
    .json<Plan>();
  return response;
};

const updatePlan = async ({
  planId,
  data,
}: {
  planId: number;
  data: PlanUpdateRequest;
}): Promise<Plan> => {
  const response = await tempoApi()
    .patch(`api/v1/adaptive-planner/plans/${planId}`, { json: data })
    .json<Plan>();
  return response;
};

const deletePlan = async ({ planId }: { planId: number }): Promise<void> => {
  await tempoApi().delete(`api/v1/adaptive-planner/plans/${planId}`);
};

export const AdaptivePlannerPlan = {
  getPlan,
  getPlans,
  updatePlan,
  deletePlan,
  createPlan,
} as const;
